<div [class]="fieldClasses">
  <label [for]="fieldId" class="n-field-label">
    {{ label }}
    @if (required) {
    <span class="n-required-indicator">*</span>
    }
  </label>

  <div class="n-field-input-container">
    @if (iconPrefix) {
    <div class="n-input-with-icon">
      <i [class]="iconPrefix" class="n-field-icon"></i>
      <ng-content></ng-content>
    </div>
    } @else {
    <ng-content></ng-content>
    }
  </div>

  @if (helpText && !hasError) {
  <small class="n-field-help">{{ helpText }}</small>
  }

  <!-- Mensagens de erro -->
  @if (showError('required')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    {{ label }} é obrigatório
  </small>
  } @if (showError('email')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    Informe um email válido
  </small>
  } @if (showError('minlength')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    Mínimo de {{ control?.errors?.['minlength']?.requiredLength }} caracteres
  </small>
  } @if (showError('maxlength')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    Máximo de {{ control?.errors?.['maxlength']?.requiredLength }} caracteres
  </small>
  } @if (showError('pattern')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    Formato inválido
  </small>
  } @if (showError('min')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    Valor mínimo: {{ control?.errors?.['min']?.min }}
  </small>
  } @if (showError('max')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    Valor máximo: {{ control?.errors?.['max']?.max }}
  </small>
  }

  <!-- Erro genérico para outros tipos de validação -->
  @if (hasError && !showError('required') && !showError('email') &&
  !showError('minlength') && !showError('maxlength') && !showError('pattern') &&
  !showError('min') && !showError('max')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    {{ label }} contém erro de validação
  </small>
  }
</div>
